export default __webpack_public_path__ + "static/media/aboutCat2M.0d33251e.webp";